import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import logo from '../../assets/images/acumenVelocityLogo.svg';
import { useNavigate } from 'react-router-dom';

const ApprovalRequestSent = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className='d-flex gap-2 justify-content-start align-items-center mt-2 mx-3 cursor_pointer' onClick={() => navigate('/')}>
                <Image alt='logo' src={logo} height={40} className='logo' />
                <p className='name fs_16 fw_700'>Acumen Translation Hub</p>
            </div>
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '90vh' }}>
                <Row>
                    <Col>
                        <Card className="text-center">
                            <Card.Body>
                                <Card.Title>Request Sent</Card.Title>
                                <Card.Text>
                                    Your request has been sent and is currently under review. Please wait for approval.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ApprovalRequestSent;
